import type { Action, ThunkAction } from '@reduxjs/toolkit'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { MakeStore, createWrapper } from 'next-redux-wrapper'
import { useDispatch, useSelector, useStore } from 'react-redux'

import globalSlice from './globalSlice'
import modalSlice from './modalSlice'
import navSlice from './navSlice'
import wishlistSlice from './wishlistSlice'

// Store setup

const reducers = {
  [globalSlice.name]: globalSlice.reducer,
  [modalSlice.name]: modalSlice.reducer,
  [wishlistSlice.name]: wishlistSlice.reducer,
  [navSlice.name]: navSlice.reducer,
}

const rootReducer = combineReducers(reducers)
export type RootState = ReturnType<typeof rootReducer>

export const makeStore: MakeStore<any> = ({ reduxWrapperMiddleware }: any) =>
  configureStore({
    reducer: rootReducer,
    devTools: false,
    middleware: (getDefaultMiddleware) =>
      [...getDefaultMiddleware(), reduxWrapperMiddleware].filter(
        Boolean,
      ) as any,
  })

export type AppStore = ReturnType<typeof makeStore>
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = AppStore['dispatch']
export type AppThunk<ThunkReturnType = void> = ThunkAction<
  ThunkReturnType,
  RootState,
  unknown,
  Action
>
export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()
export const useAppStore = useStore.withTypes<AppStore>()

export const wrapper = createWrapper<AppStore>(makeStore, { debug: false })
